import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import { Launch } from '@material-ui/icons';
import { withNamespaces } from 'react-i18next';
import { PlutoLogo } from '../styles/loading';
import { ExternalLink } from '../../userAccount/components/ExternalLink';
import { EMBED_NOTIFICATION_DELAY_IN_MS } from '../constants/time';

const PlutoLogoStyled = styled(PlutoLogo)`
  width: 190px;
  margin: 0 auto;
`;

const NotificationContainer = styled.div`
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  margin: 0 auto;
  text-align: center;
  // for Homepage L1 player
  @media (max-width: 160px) {
    display: none;
  }
`;

const AdVerbiage = styled.div`
  color: rgb(255, 255, 255);
  font-family: 'Pluto Sans SemiBold';
  font-size: 35px;
  letter-spacing: 0;
  position: relative;
  width: 80%;
  margin: 0 auto 30px auto;
`;

const Yellow = styled.div`
  font-family: 'Pluto Sans SemiBold';
  color: rgb(255, 255, 59);
  font-size: 18px;
  margin-bottom: 30px;
  line-height: 20px;
`;

const OpenAppLink = styled(ExternalLink)`
  color: #fff;
  text-decoration: none;
  margin: 0 auto;
`;

// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  button: {
    backgroundColor: '#FFEB3B',
    color: 'black',
    padding: '2px 23px',
    marginTop: '15px',
    fontSize: '18px',
    borderRadius: 30,
  },
});

const LinkButton = styled(Button)`
  margin: 0;
`;
class EmbedNotification extends PureComponent {
  static propTypes = {
    isEmbed: PropTypes.bool.isRequired,
    linkClickBeacon: PropTypes.func.isRequired,
  };

  state = {
    showNotification: false,
  };

  componentDidMount() {
    this.timerSet();
  }

  timerSet = () => {
    setTimeout(() => {
      this.setState({ showNotification: true });
    }, EMBED_NOTIFICATION_DELAY_IN_MS);
  };

  render() {
    const { classes, isEmbed, i18n, t, linkClickBeacon } = this.props;

    if (!isEmbed || !this.state.showNotification) {
      return null;
    }

    return (
      <Slide direction="up" in mountOnEnter unmountOnExit>
        <NotificationContainer>
          {i18n.language.includes('en') && (
            <AdVerbiage>
              {t('embed_ad_verbiage_1', 'Want more? Watch 100s of Channels Free.')}
            </AdVerbiage>
          )}
          <PlutoLogoStyled alt="Pluto TV logo" path="images/logoSplash.svg" />
          <Yellow>{t('drop_in_watch_free', "Drop In. Watch Free.")}</Yellow>
          <OpenAppLink onClick={linkClickBeacon} to="https://pluto.tv">
            <LinkButton variant="contained" size="small" color="primary" className={classes.button}>
              {t('open_web_app', 'Open Web App')}
              <Launch />
            </LinkButton>
          </OpenAppLink>
        </NotificationContainer>
      </Slide>
    );
  }
}

export const EmbedNotificationComponent = withStyles(styles)(withNamespaces()(EmbedNotification));
